import AnswerPanel from './answer_panel';

export default AnswerPanel;
